// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "0c4ede08f1d85a39c26deef5e6cb02d7" + ".js";
};